/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAvailableFeaturesControllerFindAllQueryResponse,
  TelegramAvailableFeaturesControllerFindAllQueryParams,
} from '../types/TelegramAvailableFeaturesControllerFindAll.ts';

function getTelegramAvailableFeaturesFindAllUrl() {
  const res = { method: 'GET', url: `/api/telegram/available-features` as const };
  return res;
}

/**
 * {@link /api/telegram/available-features}
 */
export async function telegramAvailableFeaturesFindAll(
  params?: TelegramAvailableFeaturesControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramAvailableFeaturesControllerFindAllQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: getTelegramAvailableFeaturesFindAllUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
